import { Injectable, inject } from '@angular/core';
import { AttendanceLegacyApiConfiguration } from '@attendance/legacy-api/attendance-legacy-api-configuration.class';
import { HttpService } from '@nha/api/shared';
import { Observable } from 'rxjs';

import { IStudentSummary } from '../types/student-summary.type';

@Injectable({
	providedIn: 'root'
})
export class StudentSummaryService extends HttpService {
	constructor() {
		const config = inject(AttendanceLegacyApiConfiguration);

		super(config, 'student');
	}

	getStudentSiblings(studentID: number): Observable<IStudentSummary[]> {
		return this.http.get<IStudentSummary[]>(`${this.serviceUrl}/${studentID}/siblings`);
	}
}
